import { JSONSchemaType  } from "ajv";
import { JSONSchemaBridge } from "uniforms-bridge-json-schema";
import { initializeAJV } from "/imports/api/_jsonSchemas/schemas/jsonSchemaCheck"
import ajvErrors from "ajv-errors";

/** @see https://ajv.js.org/keywords.html */

export const initJSONschema = <T>(
  schema: JSONSchemaType<T>
): JSONSchemaBridge => {
  const ajv = initializeAJV();
  ajvErrors(ajv);

  function createValidator(s: JSONSchemaType<T>) {
    try {
      const validate = ajv.compile(s);

      return (model: Record<string, unknown>) => {
        validate(model);

        if (validate.errors && validate.errors.length) {
          console.log("validation error:", validate.errors, model);
          return { details: validate.errors };
        }
        return undefined;
      };
    } catch (e) {
      console.error("schema error", { s, e });
    }
  }

  const schemaValidator = createValidator(schema as JSONSchemaType<T>);
  const bridge = new JSONSchemaBridge({ schema, validator: schemaValidator });
  return bridge;
};
